import React, { useState, useRef } from 'react';
import { getMonthlyStatement } from '../../service/SpatApi';
import { convertTimestampToDate, areDatesEqual } from "../../utils/Utilities";
import { printHtmlContent } from "../../utils/printTemplate";

import '../general/General.css';
const MonthlyStatement = () => {
  const [filters, setFilters] = useState({
    familyId: '',
    from: '',
    to: '',
    categoryDesc: '',
    subcategoryDesc: ''
  });


  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const tableRef = useRef();



  // Handle input changes, clear subcategory when category changes
  const handleInput = e => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'categoryDesc' && { subcategoryDesc: '' }),
    }));
  };

  const runQuery = async () => {
    const { familyId, from, to } = filters;

    if (!from || !to) {
      setError('தயவுசெய்து தொடக்கம் மற்றும் முடிவு தேதிகளை உள்ளிடவும்.');
      return;
    }

    const fromDate = new Date(from);
    const toDate = new Date(to);

    if (fromDate > toDate) {
      setError('"தொடக்கம் தேதி" முடிவு தேதிக்குப் பிறகு இருக்க முடியாது.');
      return;
    }

    const diffInDays = (toDate - fromDate) / (1000 * 60 * 60 * 24);
    if (diffInDays > 92) {
      setError('தேதி வரம்பு 3 மாதங்களை மீறக்கூடாது.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const queryParams = {
        from,
        to,
        ...(familyId && { familyId }),
      };

      const resp = await getMonthlyStatement(queryParams);

      // Sort transactions by transactionDate ascending
      const sortedTransactions = (resp.transactions || []).sort((a, b) => {
        const dateA = a.transactionDate.toDate ? a.transactionDate.toDate() : new Date(a.transactionDate);
        const dateB = b.transactionDate.toDate ? b.transactionDate.toDate() : new Date(b.transactionDate);
        return dateA - dateB; // ascending order
      });

      setTransactions(sortedTransactions);
    } catch (err) {
      console.error(err);
      setError('மாதாந்திர அறிக்கையை ஏற்ற முடியவில்லை.');
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    if (!tableRef.current) return;

    printHtmlContent(tableRef.current.innerHTML, {
      title: 'மாதாந்திர அறிக்கை',
      header: 'என் நிதி பயன்பாடு',
      footer: 'இது கணினி மூலம் உருவாக்கப்பட்ட அறிக்கை.',
      from: filters.from,
      to: filters.to,
    });
  };

  return (
    <>
      <h2>மாதாந்திர கணக்கு</h2>
      <br />

      <div className="auth_element">
        <label className="auth_label">
          தேதி முதல்:
          <input
            className="auth_input"
            name="from"
            type="date"
            value={filters.from}
            onChange={handleInput}
          />
        </label>

        <label className="auth_label">
          தேதி வரை:
          <input
            className="auth_input"
            name="to"
            type="date"
            value={filters.to}
            onChange={handleInput}
          />
        </label>


        <button className="auth_button" onClick={runQuery} disabled={loading}>
          {loading ? 'ஏற்றுகிறது…' : 'அறிக்கையை பெறவும்'}
        </button>

        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>

      {transactions.length > 0 ? (
        <>
          <button onClick={handlePrint} style={{ margin: '1rem 0' }}>
            🖨️  அச்சிடு
          </button>
          <div className="table-container" ref={tableRef}>
            <table className="table">
              <thead>
                <tr>
                  <th>தேதி</th>
                  <th>விவரங்கள்</th>
                  <th>வரவு</th>
                  <th>செலவு</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((d, index) => {
                  const effectiveDateStr = convertTimestampToDate(d.effectiveDate).toLocaleDateString();
                  const transactionDateStr = convertTimestampToDate(d.transactionDate).toLocaleDateString();

                  // Description content
                  let description = `${d.categoryDescription} ${d.subCategoryDescription||''}`;

                  const datesDiffer = !areDatesEqual(
                    convertTimestampToDate(d.transactionDate),
                    convertTimestampToDate(d.effectiveDate)
                  );
                  if (datesDiffer) {
                    description += ` (பரிவர்த்தனை தேதி: ${transactionDateStr})`;
                  }

                  return (
                    <tr key={index}>
                      <td>{effectiveDateStr}</td>
                      <td>{description}</td>
                      <td>{d.transactionType === 'credit' ? `ரூ. ${d.amount}` : ''}</td>
                      <td>{d.transactionType === 'debit' ? `ரூ. ${d.amount}` : ''}</td>
                    </tr>
                  );
                })}
              </tbody>

            </table>
          </div>
        </>
      ) : (
        !loading && <p>கொடுக்கப்பட்ட தேதிக்கான பதிவுகள் இல்லை.</p>
      )}
    </>
  );
};

export default MonthlyStatement;
